// extracted by mini-css-extract-plugin
export default {"table_root":"emptyData_table_root__ki2dA","empty_root":"emptyData_empty_root__l8aJX","image_inner":"emptyData_image_inner__qcFFu","title":"emptyData_title__PzKns"};